<template>
  <div
    v-for="(summary, index) in summaries"
    v-show="summary.items.length"
    :key="index"
    class="self-stretch px-8 pt-8 pb-4 border-racq-pale-blue-border border-t flex-col justify-start items-start gap-4 flex"
    :class="index === summaries.length - 1 ? '' : 'border-b'"
  >
    <div class="self-stretch pb-1 flex-col justify-start items-start gap-2 flex">
      <div class="self-stretch justify-start items-center gap-3 inline-flex">
        <BaseIcon v-if="summary.icon?.value" :iconClass="summary.icon?.value" />
        <div class="grow shrink basis-0 text-racq-dark-grey text-lg-bold">
          <Text :field="summary.summaryTitle" />
        </div>
      </div>
    </div>
    <div class="self-stretch flex-col justify-start items-start gap-4 flex">
      <ReviewSummaryItem
        v-for="(item, itemIndex) in summary.items"
        :key="itemIndex"
        :item="item"
        :isLastReviewSummaryItem="itemIndex === summary.items.length - 1"
      >
        <template #title>
          <div class="relative">
            <RichText :field="item.title" class="text-racq-dark-grey text-base-bold" />
          </div>
        </template>
        <template #content>
          <RichText :field="item.content" class="text-base text-block" />
        </template>
        <template #edit>
          <button
            v-if="item.editUrl != null && item.showEdit"
            type="button"
            class="link text-base-bold"
            @click="goToStep(item.editUrl)"
          >
            Edit
          </button>
        </template>
      </ReviewSummaryItem>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFormStore } from '@/store';
import { IReviewSummary } from '@/interfaces';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import ReviewSummaryItem from '@/components/ReviewSummary/ReviewSummaryItem.vue';
import BaseIcon from '@/components/BaseIcon/BaseIcon.vue';

defineProps<{
  summaries: IReviewSummary[];
}>();

const formStore = useFormStore();

const goToStep = (uuid: string) => {
  formStore.goToStepUsingUUID(uuid);
};
</script>
